/* Libraries */
import Link from 'next/link';
import cn from 'classnames';
/* Components */
import { Grid } from 'ht-styleguide';

/* Helpers & constants */
import { SegmentTrackingAction } from '@integrations/segment/search';
import { PROMO_DETAILS } from '../constants';

/* Styles */
import styles from '../searchbar.module.scss';

/* Types */
type PromoBlockProps = {
  className?: string;
  title: string;
  text: string;
  paddedImage: boolean;
  link: string;
  onClick: $FixMe;
  image: string;
};

type PromoBlocksProps = {
  iconClick: $FixMe;
  searchTerm: string;
};

const PromoBlock = ({ className, title, text, image, paddedImage, link, onClick }: PromoBlockProps) => {
  const rowStyles = cn(className, styles.rowWrapper, {
    'padding-small2': paddedImage,
    'paddingX-medium': !paddedImage,
    [styles.rowSingleBlock]: PROMO_DETAILS.length === 1,
  });

  const imageStyles = cn(styles.image, {
    'paddingTop-small': paddedImage,
  });

  return (
    <Link href={link}>
      <div className={rowStyles}>
        <div className={styles.imageColumn} onClick={onClick}>
          <img alt={text} className={imageStyles} src={`/${image}`} />
        </div>
        <div className="paddingLeft-small">
          <h5 className={styles.title}>{title}</h5>
          {text && <p className="p1">{text}</p>}
        </div>
      </div>
    </Link>
  );
};

const PromoBlocks = ({ iconClick, searchTerm }: PromoBlocksProps) => {
  const PromoBlockMapped = PROMO_DETAILS.map(promo => {
    const onClick = () => {
      SegmentTrackingAction.search({ searchTerm, clickedItem: 'plan promo', attributes: null });
      iconClick();
    };
    return (
      <PromoBlock
        key={promo.id}
        title={promo.title}
        text={promo.text}
        paddedImage={promo.paddedImage}
        link={promo.link}
        onClick={onClick}
        image={promo.image}
      />
    );
  });

  return (
    <Grid.FullWidth>
      <div className={styles.mobile}>{PromoBlockMapped}</div>
      <div className={styles.desktop}>{PromoBlockMapped}</div>
    </Grid.FullWidth>
  );
};

export default PromoBlocks;
